export const _404 = () => {
  return <div>404</div>;
};
